import http from '../../../app/services/httpServices';
import URL_UTILITY from '../../../app/utility/url.utility';

const getPendingEmailCount = (context, payload) => {
  return http.getApi(
    URL_UTILITY.generateRequestUrl + '/admin-email-status-count',
    payload
  );
};
const getPendingEmailData = (context, payload) => {
  return http.getApi(
    URL_UTILITY.generateRequestUrl + '/admin-email-status',
    payload
  );
};
export default {
  getPendingEmailCount,
  getPendingEmailData
};
